import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchUserInfo } from '../utils/services/fetchUser'
import styled from 'styled-components'
import UpdatePrivateProfile from '../components/PrivateProfile/UpdatePrivateProfile'
import DeleteProfile from '../components/PrivateProfile/DeleteProfile'
import Sidebar from '../components/shared/Sidebar'

const StyledPrivateProfile = styled.div`
    justify-content: center;
    margin: auto;
    display: flex;
    width: 100vw;
    max-width: 1500px;
`
const StyledUpdatePrivateProfile = styled(UpdatePrivateProfile)``

const PrivateProfile = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const [isVisible, setIsDeleteVisible] = useState(false)

    // Get user info
    const { data: userInfo } = useQuery({
        queryKey: ['userInfo'],
        queryFn: fetchUserInfo,
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    if (!userInfo) {
        return <div>Pas connecté</div>
    }

    return (
        <StyledPrivateProfile>
            {userInfo && (
                <Sidebar
                    setIsSidebarOpen={setIsSidebarOpen}
                    isSidebarOpen={isSidebarOpen}
                    userInfo={userInfo}
                />
            )}
            <StyledUpdatePrivateProfile
                setIsDeleteVisible={setIsDeleteVisible}
                userInfo={userInfo}
            />
            {isVisible && (
                <DeleteProfile
                    setIsDeleteVisible={setIsDeleteVisible}
                    userInfo={userInfo}
                />
            )}
        </StyledPrivateProfile>
    )
}

export default PrivateProfile
